import React, { Component } from 'react';
import ExamTitle from '../component/header/examTitle/examTitle';
import StudentInfoBtn from '../component/header/studentInfoBtn/studentInfoBtn';
import ExamTimer from '../component/header/time/examTimer';
import StudentInfo from '../component/studentInfo/studentInfo';
import imgUser from "../img/no-profile.png";
import SheetsRow from '../component/exam/sheet/sheetsRow';
import SelectSheet from '../component/exam/sheet/selectSheet';
import EmptySheet from '../component/exam/sheet/emptySheet';

class ExamResult extends Component {
    render() {
        const token = JSON.parse(localStorage.getItem("userInfo"));
        return (
            <div className="resultView-wrap wrap d-flex flex-column">
                <header className="d-flex align-items-center justify-content-between">
                    <div className="d-flex flex-grow-1 align-items-center justify-content-between">
                        <StudentInfoBtn onOpen={this.props.onOpen} />
                        <ExamTitle />
                        <div className="d-flex align-items-center right"><ExamTimer /></div>
                    </div>
                </header>
                <StudentInfo currentClass={this.props.currentClass} onClose={this.props.onClose} />

                <section className="main-container w-100 d-flex flex-column justify-content-center align-items-center scroll-wrapper">
                    <div>
                        <article className="sheet-body d-flex">
                            <ul className="left m-0 d-flex flex-column align-items-center justify-content-center">
                                <li className="img-box">
                                    <img className="w-100" src={imgUser} alt="" />
                                </li>
                                <li className="table-wrap w-100">
                                    <table className="m-0">
                                        <colgroup>
                                            <col width="35%" />
                                            <col width="65%" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>시험명</th>
                                                <td>{token[0].test_name}</td>
                                            </tr>
                                            <tr>
                                                <th>시험일</th>
                                                <td>2021-03-15</td>
                                            </tr>
                                            <tr>
                                                <th>교시</th>
                                                <td>{token[0].test_sec}</td>
                                            </tr>
                                            <tr>
                                                <th>과목</th>
                                                <td>{token[0].test_name}</td>
                                            </tr>
                                            <tr>
                                                <th>응시번호</th>
                                                <td>{token[0].mb_id}</td>
                                            </tr>
                                            <tr>
                                                <th>성명</th>
                                                <td>{token[0].mb_name}</td>
                                            </tr>
                                            <tr>
                                                <th>현재 시간</th>
                                                <td>K-CBT 튜토리얼</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </li>
                            </ul>

                            <ul className="right sheet-container p-0 m-0 d-flex flex-column text-center scroll-wrapper">
                                <li className="sheet-header d-flex justify-content-center align-items-center"><b>답안 표기란</b> (* 현재 상태에서는 답안 수정이 불가합니다. 수정을 원하시면 시험시간 내 확인 후 문제풀이 화면으로 되돌아가서 수정하시기 바랍니다.)</li>
                                <li className="sheet-body sheet-wrap m-0 p-0 d-flex flex-column">
                                    <ul className="sheet-column p-0 d-flex flex-column flex-wrap">
                                        {this.props.examTotalNumber.map(item => (
                                            <SheetsRow examNum={item + 1} />
                                        ))}
                                        <SelectSheet />
                                        <EmptySheet />
                                    </ul>
                                </li>
                            </ul>

                        </article>
                        <article className="sheet-footer btn-wrap d-flex justify-content-center align-items-center">
                            <button className="btn" onClick="location.href='./waitSubmit.html'">확인</button>
                        </article>
                    </div>


                </section>
            </div>
        );
    }
}

export default ExamResult;